import { render, staticRenderFns } from "./submission_score_histogram.vue?vue&type=template&id=46ef008d&scoped=true&"
import script from "./submission_score_histogram.vue?vue&type=script&lang=ts&"
export * from "./submission_score_histogram.vue?vue&type=script&lang=ts&"
import style0 from "./submission_score_histogram.vue?vue&type=style&index=0&id=46ef008d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ef008d",
  null
  
)

export default component.exports